import {Box} from "@mui/material";
import React from "react";

interface WhiteBoxProps {
    children: React.ReactNode;
}

export const WhiteBox: React.FC<WhiteBoxProps> = ({ children }) => {
    return (
        <Box sx={{backgroundColor: "white"}} borderRadius={"8px"} padding={"20px"}>
            { children }
        </Box>
    );
}